import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { PUT_NON_NATIONAL_WITHDRAWAL_APPLICATION_STATUS } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import { GenericErrorResponse } from '../typings';

// =============================================================================
// Request & Response Model
// =============================================================================
interface PutNonNationalExamApplicationStatusRequest {
  status: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  onSettled?: () => void;
  uuid: string;
}

export const usePutNonNationalWithdrawalApplicationStatus = ({
  onSuccess,
  onError,
  onSettled,
  uuid,
}: Input) => {
  const putNonNationalWithdrawalApplicationStatus = async (
    payload: PutNonNationalExamApplicationStatusRequest
  ) => {
    const res = await axiosClient.put<void>(
      PUT_NON_NATIONAL_WITHDRAWAL_APPLICATION_STATUS(uuid),
      payload
    );
    return res.data;
  };

  return useCustomMutation(putNonNationalWithdrawalApplicationStatus, {
    onSuccess,
    onError,
    onSettled,
  });
};
